import { useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, RotateCcw } from "lucide-react";
import StepHeader from "@/components/StepHeader";
import { readAdvisorState, resetAdvisorState } from "@/data/polyFitData";
import { useAdvisorContent } from "@/hooks";
import { trackAdvisorEvent } from "@/utils/analytics";

export default function FitComparePage() {
  const navigate = useNavigate();
  const { portfolioRows } = useAdvisorContent();
  const advisorState = useMemo(() => readAdvisorState(), []);
  useEffect(() => {
    trackAdvisorEvent("compare_viewed", { sessionId: advisorState.sessionId, result_product_id: advisorState.recommendationId || "" });
  }, [advisorState.recommendationId, advisorState.sessionId]);

  const restart = () => {
    const state = resetAdvisorState();
    trackAdvisorEvent("quiz_restarted", { sessionId: state.sessionId, source: "compare" });
    navigate("/");
  };

  return (
    <main className="advisor-page compare-page" data-testid="compare-models-page">
      <StepHeader step={4} compact progressLabel="Portfolio View" />
      <section className="fit-panel compare-panel reveal-in" data-testid="compare-models-panel">
        <p className="step-kicker" data-testid="compare-models-eyebrow">PORTFOLIO VIEW</p>
        <h1 className="section-title" data-testid="compare-models-title">The recommendation logic at a glance</h1>
        <p className="muted-copy" data-testid="compare-models-helper">Use this as a summary after the interactive fit check.</p>
        <div className="table-wrap" data-testid="compare-models-table-wrap">
          <table className="portfolio-table" data-testid="compare-models-table">
            <thead><tr><th>Model</th><th>Connection</th><th>Best-fit workplace</th><th>Noise / focus step-up</th></tr></thead>
            <tbody>
              {portfolioRows.map((row) => (
                <tr className={advisorState.recommendationId === row.id ? "highlight" : ""} key={row.id} data-testid={`compare-row-${row.id}`}>
                  <td className="model-name" data-testid={`compare-row-${row.id}-model`}>{row.model}</td>
                  <td data-testid={`compare-row-${row.id}-connection`}>{row.connection}</td>
                  <td data-testid={`compare-row-${row.id}-workplace`}>{row.bestFitWorkplace}</td>
                  <td data-testid={`compare-row-${row.id}-noise`}>{row.noiseFocusStepUp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="action-row" data-testid="compare-action-row">
          <Link className="ghost-btn" to="/recommendation" data-testid="compare-back-to-result-button"><ArrowLeft size={16} /> Back to recommendation</Link>
          <button className="primary-cta" type="button" onClick={restart} data-testid="compare-restart-button"><RotateCcw size={16} /> Run the Fit Check Again</button>
        </div>
      </section>
    </main>
  );
}